var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.oneSlide)?_c('section',{staticClass:"about-us-block"},[_c('div',{staticClass:"container"},[_c('SliderWrapper',{staticClass:"slider",attrs:{"slides":_vm.aboutUsSlides}}),_c('img',{staticClass:"about-us-decor",attrs:{"src":"/images/homePage/aboutUs/about-us-block-background.png","alt":"about-us-block-decor"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }